import React from "react";
import styled from "styled-components";

import Tooltip from "@material-ui/core/Tooltip";

import { BiUser } from "react-icons/bi";

import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import StyledIconButton from "../buttons/StyledIconButton";

export default function UserChat({
  showActions,
  displayName,
  content,
  editing,
  onEditClick,
  renderEditingMessage,
}) {
  const renderUserChat = () => {
    return (
      <Container>
        <Header>
          <UserAuthorContainer>
            <BiUser />
          </UserAuthorContainer>
          <User>{displayName}</User>
          {showActions ? (
            <div className="user-chat__actions">
              {editing ? null : (
                <Tooltip title="Edit this message">
                  <div style={{ position: "relative" }}>
                    <StyledIconButton size="small" onClick={onEditClick}>
                      <EditOutlinedIcon fontSize="small" />
                    </StyledIconButton>
                  </div>
                </Tooltip>
              )}
            </div>
          ) : null}
        </Header>
        {editing && typeof renderEditingMessage === "function" ? (
          renderEditingMessage()
        ) : (
          <Content>{content}</Content>
        )}
      </Container>
    );
  };

  return renderUserChat();
}

UserChat.propTypes = {};

UserChat.defaultProps = {};

// .user-chat__actions {
//   display: none;
// }

// &:hover .user-chat__actions {
//   display: block;
// }

const Container = styled.div`
  & {
    width: 100%;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #dbdbdb;
  }
`;

const Header = styled.div`
  & {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 0.5rem;
  }
`;

const UserAuthorContainer = styled.div`
  & {
    height: 20px;
    width: 20px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: lightgrey;
  }
`;

const User = styled.div`
  & {
    fontsize: 11px;
    text-transform: uppercase;
    color: grey;
  }
`;

const Content = styled.div`
  & {
    width: 100%;
    font-size: 14px;
    white-space: pre-wrap;
    color: #434343;
    padding: 0 0 0.4rem 0;
  }
`;
